// src/pages/ScanQR.js
import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/ScanQR.css";

function ScanQR() {
  const { state } = useLocation(); // gets hotelName from previous page
  const navigate = useNavigate();
  const scannerRef = useRef(null);
  const isRunningRef = useRef(false);

  useEffect(() => {
    const scanner = new Html5Qrcode("reader");
    scannerRef.current = scanner;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText) => {
          if (isRunningRef.current) {
            isRunningRef.current = false;
            scanner.stop().then(() => {
              navigate("/qrpage", {
                state: {
                  qrData: decodedText,
                  hotelName: state?.hotelName // pass hotel name too
                }
              });
            });
          }
        },
        (errorMessage) => {
          // Optional: console.log("Scanning...", errorMessage);
        }
      )
      .then(() => {
        isRunningRef.current = true;
      })
      .catch((err) => {
        console.error("Camera start failed:", err);
      });

    return () => {
      if (isRunningRef.current && scannerRef.current) {
        scannerRef.current
          .stop()
          .then(() => {
            isRunningRef.current = false;
          })
          .catch((err) => console.warn("Stop failed:", err));
      }
    };
  }, [navigate, state?.hotelName]);

  return (
    <div className="scanqr-container">
      <h2>Scan QR Code</h2>
      <div id="reader" className="qr-reader"></div>
    </div>
  );
}

export default ScanQR; 